import { IconFormNames } from '@griply/types';
import React from 'react';

import { CalendarUpcoming, Check, ClockWatch, DotsMenu12, Inbox } from './svgs';
import * as UserSelectIcons from './user-select';

export { IconFormNames };

export const IconFormIcons: Record<
  IconFormNames,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  [IconFormNames.Inbox]: Inbox,
  [IconFormNames.CalendarUpcoming]: CalendarUpcoming,
  [IconFormNames.ArchiveDocumentsBoxBig]: CalendarUpcoming, // todo: set actual svg
  [IconFormNames.Check]: Check,
  [IconFormNames.DotsMenu]: DotsMenu12,
  [IconFormNames.ClockWatch]: ClockWatch,
  [IconFormNames.PlaceholderIcon]: UserSelectIcons.UserSelectPlaceholderIcon,
  [IconFormNames.SmartList]: UserSelectIcons.UserSelectSmartList,
  [IconFormNames.WorkAndCareer]: UserSelectIcons.UserSelectWorkAndCareer,
  [IconFormNames.MoneyAndFinance]: UserSelectIcons.UserSelectMoneyAndFinance,
  [IconFormNames.SportAndHealth]: UserSelectIcons.UserSelectSportAndHealth,
  [IconFormNames.EducationAndLearning]:
    UserSelectIcons.UserSelectEducationAndLearning,
  [IconFormNames.LoveAndRelationships]:
    UserSelectIcons.UserSelectLoveAndRelationships,
  [IconFormNames.PersonalDevelopment]:
    UserSelectIcons.UserSelectPersonalDevelopment,
  [IconFormNames.FamilyAndFriends]: UserSelectIcons.UserSelectFamilyAndFriends,
  [IconFormNames.FunAndRelaxation]: UserSelectIcons.UserSelectFunAndRelaxation,
  [IconFormNames.Spirituality]: UserSelectIcons.UserSelectSpirituality,
  [IconFormNames.SportHockey]: UserSelectIcons.UserSelectSportHockey,
  [IconFormNames.SportGolf]: UserSelectIcons.UserSelectSportGolf,
  [IconFormNames.SportBasketball]: UserSelectIcons.UserSelectSportBasketball,
  [IconFormNames.SportBaseball]: UserSelectIcons.UserSelectSportBaseball,
  [IconFormNames.SportDumbbell]: UserSelectIcons.UserSelectSportDumbbell,
  [IconFormNames.SportJumpingRope]: UserSelectIcons.UserSelectSportJumpingRope,
  [IconFormNames.SportFitnessBiceps]:
    UserSelectIcons.UserSelectSportFitnessBiceps,
  [IconFormNames.SportSneakers]: UserSelectIcons.UserSelectSportSneakers,
  [IconFormNames.SportSlimWaist]: UserSelectIcons.UserSelectSportSlimWaist,
  [IconFormNames.SportAmericanFootballHelmet]:
    UserSelectIcons.UserSelectSportAmericanFootballHelmet,
  [IconFormNames.SportMartialArtsSwordFencing]:
    UserSelectIcons.UserSelectSportMartialArtsSwordFencing,
  [IconFormNames.SportSkatingShoes]:
    UserSelectIcons.UserSelectSportSkatingShoes,
  [IconFormNames.SportTennisRacquet]:
    UserSelectIcons.UserSelectSportTennisRacquet,
  [IconFormNames.SportSnowboard]: UserSelectIcons.UserSelectSportSnowboard,
  [IconFormNames.GameController]: UserSelectIcons.UserSelectGameController,
  [IconFormNames.Phone]: UserSelectIcons.UserSelectPhone,
  [IconFormNames.Computer]: UserSelectIcons.UserSelectComputer,
  [IconFormNames.Headphones]: UserSelectIcons.UserSelectHeadphones,
  [IconFormNames.ThreeDGlasses]: UserSelectIcons.UserSelect3DGlasses,
  [IconFormNames.Television]: UserSelectIcons.UserSelectTelevision,
  [IconFormNames.Movies]: UserSelectIcons.UserSelectMovies,
  [IconFormNames.MusicNote]: UserSelectIcons.UserSelectMusicNote,
  [IconFormNames.Bitcoin]: UserSelectIcons.UserSelectBitcoin,
  [IconFormNames.Wallet]: UserSelectIcons.UserSelectWallet,
  [IconFormNames.ColorPalette]: UserSelectIcons.UserSelectColorPalette,
  [IconFormNames.GameCardsDiamond]: UserSelectIcons.UserSelectGameCardsDiamond,
  [IconFormNames.HatMagician]: UserSelectIcons.UserSelectHatMagician,
  [IconFormNames.Pen]: UserSelectIcons.UserSelectPen,
  [IconFormNames.ChefHat]: UserSelectIcons.UserSelectChefHat,
  [IconFormNames.Camera]: UserSelectIcons.UserSelectCamera,
  [IconFormNames.Hammer]: UserSelectIcons.UserSelectHammer,
  [IconFormNames.Campfire]: UserSelectIcons.UserSelectCampFire,
  [IconFormNames.Microphone]: UserSelectIcons.UserSelectMicrophone,
  [IconFormNames.Glasses]: UserSelectIcons.UserSelectGlasses,
  [IconFormNames.Backpack]: UserSelectIcons.UserSelectBackpack,
  [IconFormNames.GraduateHat]: UserSelectIcons.UserSelectGraduateHat,
  [IconFormNames.ShoppingCart]: UserSelectIcons.UserSelectShoppingCart,
  [IconFormNames.Lock]: UserSelectIcons.UserSelectLock,
  [IconFormNames.BatteryChargingLightning]:
    UserSelectIcons.UserSelectBatteryChargingLightning,
  [IconFormNames.ShoppingBag]: UserSelectIcons.UserSelectShoppingBag,
  [IconFormNames.Map]: UserSelectIcons.UserSelectMap,
  [IconFormNames.Sunrise]: UserSelectIcons.UserSelectSunrise,
  [IconFormNames.TravelBag]: UserSelectIcons.UserSelectTravelBag,
  [IconFormNames.Globe]: UserSelectIcons.UserSelectGlobe,
  [IconFormNames.Baby]: UserSelectIcons.UserSelectBaby,
  [IconFormNames.GroupPeople]: UserSelectIcons.UserSelectGroupPeople,
  [IconFormNames.Cat]: UserSelectIcons.UserSelectCat,
  [IconFormNames.Dog]: UserSelectIcons.UserSelectDog,
  [IconFormNames.Bus]: UserSelectIcons.UserSelectBus,
  [IconFormNames.Boat]: UserSelectIcons.UserSelectBoat,
  [IconFormNames.Car]: UserSelectIcons.UserSelectCar,
  [IconFormNames.Bicycle]: UserSelectIcons.UserSelectBicycle,
  [IconFormNames.Train]: UserSelectIcons.UserSelectTrain,
  [IconFormNames.Plane]: UserSelectIcons.UserSelectPlane,
  [IconFormNames.AsianFood]: UserSelectIcons.UserSelectAsianFood,
  [IconFormNames.Cake]: UserSelectIcons.UserSelectCake,
  [IconFormNames.Fish]: UserSelectIcons.UserSelectFish,
  [IconFormNames.Croissant]: UserSelectIcons.UserSelectCroissant,
  [IconFormNames.Meat]: UserSelectIcons.UserSelectMeat,
  [IconFormNames.Apple]: UserSelectIcons.UserSelectApple,
  [IconFormNames.Eggplant]: UserSelectIcons.UserSelectEggplant,
  [IconFormNames.GlassWater]: UserSelectIcons.UserSelectGlassWater,
  [IconFormNames.GlassWater2]: UserSelectIcons.UserSelectGlassWater2,
  [IconFormNames.ServingDome]: UserSelectIcons.UserSelectServingDome,
  [IconFormNames.ForkKnife]: UserSelectIcons.UserSelectForkKnife,
  [IconFormNames.ChampagneGlasses]: UserSelectIcons.UserSelectChampagneGlasses,
  [IconFormNames.GiftBox]: UserSelectIcons.UserSelectGiftBox,
  [IconFormNames.Store]: UserSelectIcons.UserSelectStore,
  [IconFormNames.LargeBuilding]: UserSelectIcons.UserSelectLargeBuilding,
  [IconFormNames.Chart]: UserSelectIcons.UserSelectChart,
  [IconFormNames.Package]: UserSelectIcons.UserSelectPackage,
  [IconFormNames.Bed]: UserSelectIcons.UserSelectBed,
  [IconFormNames.Stethoscope]: UserSelectIcons.UserSelectStethoscope,
  [IconFormNames.Fireworks]: UserSelectIcons.UserSelectFireworks,
  [IconFormNames.LaptopCode]: UserSelectIcons.UserSelectLaptopCode,
  [IconFormNames.Leaf]: UserSelectIcons.UserSelectLeaf,
  [IconFormNames.RewardCup]: UserSelectIcons.UserSelectRewardCup,
  [IconFormNames.Stars]: UserSelectIcons.UserSelectStars,
  [IconFormNames.Rocket]: UserSelectIcons.UserSelectRocket,
  [IconFormNames.AiChip]: UserSelectIcons.UserSelectAiChip,
  [IconFormNames.BookOpen]: UserSelectIcons.UserSelectBookOpen,
  [IconFormNames.LabTube]: UserSelectIcons.UserSelectLabTube,
  [IconFormNames.Sun]: UserSelectIcons.UserSelectSun,
  [IconFormNames.Snow]: UserSelectIcons.UserSelectSnow,
  [IconFormNames.BandageShoulder]: UserSelectIcons.UserSelectBandageShoulder,
  [IconFormNames.Coins]: UserSelectIcons.UserSelectCoins,
  [IconFormNames.CoinsDocumentChart]:
    UserSelectIcons.UserSelectCoinsDocumentChart,
  [IconFormNames.Dollar]: UserSelectIcons.UserSelectDollar,
  [IconFormNames.Euro]: UserSelectIcons.UserSelectEuro,
  [IconFormNames.ExamAGradeSquare]: UserSelectIcons.UserSelectExamAGradeSquare,
  [IconFormNames.Gbp]: UserSelectIcons.UserSelectGbp,
  [IconFormNames.HealthReport]: UserSelectIcons.UserSelectHealthReport,
  [IconFormNames.Heartbeat]: UserSelectIcons.UserSelectHeartbeat,
  [IconFormNames.HomeHouse]: UserSelectIcons.UserSelectHomeHouse,
  [IconFormNames.HomeHouseKey]: UserSelectIcons.UserSelectHomeHouseKey,
  [IconFormNames.LanguageTranslateMessage]:
    UserSelectIcons.UserSelectLanguageTranslateMessage,
  [IconFormNames.LoveChat]: UserSelectIcons.UserSelectLoveChat,
  [IconFormNames.Medicine]: UserSelectIcons.UserSelectMedicine,
  [IconFormNames.MountainsCloud]: UserSelectIcons.UserSelectMountainsCloud,
  [IconFormNames.Pendant]: UserSelectIcons.UserSelectPendant,
  [IconFormNames.Percentage]: UserSelectIcons.UserSelectPercentage,
  [IconFormNames.PiggyBank]: UserSelectIcons.UserSelectPiggyBank,
  [IconFormNames.SportBoxingGlove]: UserSelectIcons.UserSelectSportBoxingGlove,
  [IconFormNames.SportDivingMask]: UserSelectIcons.UserSelectSportDivingMask,
  [IconFormNames.SportFieldSoccerField]:
    UserSelectIcons.UserSelectSportFieldSoccerField,
  [IconFormNames.SportFootball]: UserSelectIcons.UserSelectSportFootball,
  [IconFormNames.SportHockeyStickPuck]:
    UserSelectIcons.UserSelectSportHockeyStickPuck,
  [IconFormNames.SportRings]: UserSelectIcons.UserSelectSportRings,
  [IconFormNames.SportRugbyBall]: UserSelectIcons.UserSelectSportRugbyBall,
  [IconFormNames.SportSportsHelmet]:
    UserSelectIcons.UserSelectSportSportsHelmet,
  [IconFormNames.SportSurfingBoard]:
    UserSelectIcons.UserSelectSportSurfingBoard,
  [IconFormNames.SportSwimmingPool]:
    UserSelectIcons.UserSelectSportSwimmingPool,
  [IconFormNames.SportTennisNet]: UserSelectIcons.UserSelectSportTennisNet,
  [IconFormNames.SportWaterpoloBall]:
    UserSelectIcons.UserSelectSportWaterpoloBall,
  [IconFormNames.SportYoga]: UserSelectIcons.UserSelectSportYoga,
  [IconFormNames.Target]: UserSelectIcons.UserSelectTarget,
  [IconFormNames.Teeth]: UserSelectIcons.UserSelectTeeth,
  [IconFormNames.UserHeartHealth]: UserSelectIcons.UserSelectUserHeartHealth,
  [IconFormNames.Repeat]: UserSelectIcons.UserSelectRepeat,
  [IconFormNames.WeddingRings]: UserSelectIcons.UserSelectWeddingRings,
  [IconFormNames.Yen]: UserSelectIcons.UserSelectYen,
  [IconFormNames.Clock]: UserSelectIcons.UserSelectClockWatch,
  [IconFormNames.Distance]: UserSelectIcons.UserSelectDistance,
  [IconFormNames.Hashtag]: UserSelectIcons.UserSelectHashtag,
  [IconFormNames.Ruler]: UserSelectIcons.UserSelectRuler,
  [IconFormNames.ToDoList]: UserSelectIcons.UserSelectToDoList,
};
